import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import type { User } from '@recruitee/account-types';
import { HttpApiService } from '@recruitee/http';
import type { PaginationMeta, PaginationParams } from '@recruitee/http-types';
import type { InterviewSchedule } from '@recruitee/interview-schedules-types';

import { InterviewSchedulesCollectionScopes } from './collection.types';

@Injectable({ providedIn: 'root' })
export class InterviewSchedulesCollectionHttpClient {
  constructor(protected httpApi: HttpApiService) {}

  public loadCollection(
    scope: string,
  ): Observable<{ interviewSchedules: InterviewSchedule[]; references: User[] }> {
    return this.httpApi.get(
      scope === InterviewSchedulesCollectionScopes.Available
        ? 'interview/schedules/available'
        : 'interview/schedules',
    );
  }

  public loadPaginatedCollection(
    params: PaginationParams,
  ): Observable<{ rows: InterviewSchedule[]; meta: PaginationMeta; references: User[] }> {
    return this.httpApi.get('interview/schedules', params).pipe(
      map(data => ({
        meta: data.meta,
        rows: data.interviewSchedules,
        references: data.references,
      })),
    );
  }
}
